import React from 'react';
import { Droppable, Draggable } from '@hello-pangea/dnd';
import KanbanCard from '../Tasks/KanbanCard';

export default function KanbanCardsColumn({ board, cards, onCardClick }) {
  const droppableId = String(board.boardID);

  return (
    <div className="kanban-column kanban-cards-cell">
      <div className="kanban-column-wrapper kanban-cards-wrapper">
        <Droppable droppableId={droppableId}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className={`kanban-column-cards${snapshot.isDraggingOver ? ' drag-over' : ''}`}
            >
              {cards.map((card, index) => (
                <Draggable
                  key={String(card.cardID)}
                  draggableId={String(card.cardID)}
                  index={index}
                >
                  {(dragProvided, dragSnapshot) => (
                    <KanbanCard
                      card={card}
                      isDragging={dragSnapshot.isDragging}
                      innerRef={dragProvided.innerRef}
                      draggableProps={dragProvided.draggableProps}
                      dragHandleProps={dragProvided.dragHandleProps}
                      style={dragProvided.draggableProps.style}
                      onCardClick={onCardClick}
                    />
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    </div>
  );
}
